import { useGuideViewModel } from './guide.viewModel';
import { registerContext } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { GuideView } from './Guide.view';

export const guideVM = registerContext('guideVM', useGuideViewModel);

export const GuidePage = (p: { params: { influencerId?: string } }) => {
  return (
    <guideVM.ValueProvider
      params={p.params}
      renderer={(vm) => <GuideView {...vm} />}
    />
  );
};
